var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mask', _vm.show ? 'maskShow' : 'maskHide'],style:({
        display: _vm.waitrun ? `flex` : `none`,
        zIndex: _vm.show ? 2000 : -1,
    }),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('mask')}}},[(_vm.waitrun)?_c('div',{class:['inner', _vm.show ? 'innerShow' : 'innerHide']},[_c('div',{staticClass:"inner_main"},[_c('div',{staticClass:"inner_content"},[_vm._t("main")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }